import Image from "next/image";

const logos = {
  wordmark: { src: "/brand/logo.png", width: 560, height: 128 },
  domain: { src: "/brand/logo_d.png", width: 795, height: 128 },
} as const;

export function BrandLogo({
  variant = "wordmark",
  className = "h-8 w-auto",
}: {
  variant?: keyof typeof logos;
  className?: string;
}) {
  const logo = logos[variant];
  return (
    <Image
      src={logo.src}
      alt="Sverim"
      width={logo.width}
      height={logo.height}
      priority={variant === "wordmark"}
      className={className}
    />
  );
}
